import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shop } from '@shared/components/ui/shop';
import { Customer } from '../../models';
import { customerOriginHelpers } from '../../constants';
import { getOrderTypeLabel } from '../../utils/orderTypeHelpers';

interface CustomerMobileCardProps {
  customer: Customer;
}

export const CustomerMobileCard = ({ customer }: CustomerMobileCardProps) => {
  const { t } = useTranslation(['marketingModule', 'createEditClientsModule']);

  return (
    <div className="rounded-lg border border-border bg-card p-3 transition-colors">
      <Shop name={customer.name} src={customer.logo_hash} className="py-0 mb-2" />
      <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs">
        <span className="text-muted-foreground">{t('customerTable.headers.email', 'Correo')}</span>
        <span className="text-foreground truncate text-right">{customer.email_admin}</span>
        <span className="text-muted-foreground">{t('customerTable.headers.firstEntry', '1ª entrada')}</span>
        <span className="text-foreground text-right tabular-nums">
          {customer.first_entry_at ? customer.first_entry_at.split('-').reverse().join('/') : '-'}
        </span>
        <span className="text-muted-foreground">{t('customerTable.headers.saleType', 'Tipo venta')}</span>
        <span className="text-foreground text-right">{getOrderTypeLabel(customer.order_type)}</span>
        <span className="text-muted-foreground">{t('customerTable.headers.source', 'Fuente')}</span>
        <span className="text-foreground text-right">
          {customerOriginHelpers.getSourceLabel(customer.customer_origin, t)}
        </span>
      </div>
    </div>
  );
};
